import { render } from "./LocationNotifications.vue?vue&type=template&id=47c4cb06"
import script from "./LocationNotifications.vue?vue&type=script&lang=js"
export * from "./LocationNotifications.vue?vue&type=script&lang=js"

import "./LocationNotifications.vue?vue&type=style&index=0&id=47c4cb06&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__